/*
 * @Author: linguang linguang@nextmar.com
 * @Date: 2025-04-02 18:28:59
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-06-24 11:47:28
 * @FilePath: /src/app/account/refer-a-friend/components/ShareStat.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
'use client';
import { clearInviteNotify } from '@/api/account';
import WapOnly from '@/components/Responsive/WapOnly';
import WebOnly from '@/components/Responsive/WebOnly';
import { useStore } from '@/providers/app-store-provider';
import { numberFormatToThousands } from '@/utils/math';
import { formatPriceNumberWithSymbol } from '@/utils/price';
import { IconButton, Tooltip } from '@mui/material';
import { QuestionFilled, QuestionOutlined } from '@zeelool/icon';
import { useTranslations } from 'next-intl';
import { useEffect, useState } from 'react';
import { useInviteFriendStore } from '../store/invite-friend-store';
import styles from './index.module.scss';

interface IShareStatProps {
  click_share: number;

  friends_referred: number;

  total_get_points: number;

  total_get_moneys: number;

  discountLimit: number;
  isAuthenticated: boolean;
}

const ShareStat = (props: IShareStatProps) => {
  // Get translations
  const t = useTranslations('account.referAFriend.shareStat');
  const currency = useStore((state) => state.currency);
  const { discountLimit } = props;
  const { shareStats, updateShareStats } = useInviteFriendStore();
  const openRuleDialogWithType = useInviteFriendStore((state) => state.openRuleDialogWithType);
  const userInfo = useStore((state) => state.userInfo);
  const refreshAccountInfo = useStore((state) => state.refreshAccountInfo);
  const [isAuthenticated, setIsAuthenticated] = useState(props.isAuthenticated);
  const token = useStore((state) => state.token);

  // Define card array with translations
  const cardArrs = [
    {
      title: t('clickShare'),
      key: 'click_share',
    },
    {
      title: t('friendsReferred'),
      key: 'friends_referred',
    },
    {
      title: t('totalGet'),
      key: 'total_get_moneys',
    },
  ];

  // Initialize store with props data if store is empty but props have data
  useEffect(() => {
    if (
      (shareStats.click_share === 0 && props.click_share !== 0) ||
      (shareStats.friends_referred === 0 && props.friends_referred !== 0) ||
      (shareStats.total_get_points === 0 && props.total_get_points !== 0) ||
      (shareStats.total_get_moneys === 0 && props.total_get_moneys !== 0)
    ) {
      // Initialize with props if store is empty but has initial props data
      updateShareStats({
        click_share: props.click_share,
        friends_referred: props.friends_referred,
        total_get_points: props.total_get_points,
        total_get_moneys: props.total_get_moneys,
      });
    }
  }, [
    props.click_share,
    props.friends_referred,
    props.total_get_points,
    props.total_get_moneys,
    updateShareStats,
  ]);

  useEffect(() => {
    if (token) {
      handleShareAnimation();
      setIsAuthenticated(true);
    }
  }, [token]);

  const handleShareAnimation = async () => {
    if (userInfo?.invite_points?.inviter?.point) {
      const el = document.getElementById('shareStat');
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' });
        await clearInviteNotify({ type: 'inviter' });
        const number = document.getElementById('animatedNumber');
        number.classList.add('scale-150'); // 添加类名开始放大
        setTimeout(() => {
          refreshAccountInfo();
        }, 200);
        setTimeout(() => {
          number.classList.remove('scale-150'); // 移除类名恢复原状
        }, 1500);
      }
    }
  };

  useEffect(() => {
    handleShareAnimation();
  }, []);

  // 构建问号图标组件，根据平台不同渲染不同的组件
  const QuestionIcon = ({ type }: { type: 'friends' | 'points' }) => (
    <>
      <WebOnly>
        <Tooltip
          title={
            type === 'friends' ? t('friendsReferredTooltip') : t('pointsTooltip', { discountLimit })
          }
          arrow
          placement="top"
        >
          <IconButton size="small" className="ml-1">
            <QuestionFilled className="text-[12px] text-secondary-text" />
          </IconButton>
        </Tooltip>
      </WebOnly>

      <WapOnly>
        <IconButton size="small" className="ml-1" onClick={() => openRuleDialogWithType(type)}>
          <QuestionOutlined className="text-[3.467vw] text-secondary-text" />
        </IconButton>
      </WapOnly>
    </>
  );

  if (!isAuthenticated) return null;

  return (
    <div
      id="shareStat"
      className="bg-white lg:bg-transparent rounded-[3.2vw] lg:rounded-none w-full lg:w-[60.83vw] mx-auto overflow-hidden"
    >
      <p className="bg-[#b2bfff] h-[12.533vw] leading-[12.533vw] text-left pl-[4vw] f16 mb-7 font-bb f16 lg:h-auto lg:bg-transparent lg:leading-normal lg:text-center lg:mt-[2.6vw] lg:mb-[1.146vw]">
        {t('title')}
      </p>

      <div className={`flex justify-between p-[5.333vw_4vw_6.4vw] lg:p-0 `}>
        {cardArrs.map((item, index) => (
          <div
            key={index}
            className={`${styles.marginRight} lg:w-[32.26%] lg:bg-[#F5F6F7] rounded-[8px] flex flex-col items-center lg:pt-[1.458vw] ${index === 2 ? 'lg:pb-[0.625vw]' : 'lg:pb-[1.875vw]'} mb-4 md:mb-0 lg:w-[19.6875vw] lg:h-[7.458vw]`}
          >
            <div className="uppercase flex items-center text-[3.2vw] lg:text-[14px] h-[3.733vw] leading-[3.733vw] lg:leading-[14px] mb-[2.133vw] lg:mb-[.625vw]">
              <span className="text-center" dangerouslySetInnerHTML={{ __html: item.title }} />
              {index === 1 && <QuestionIcon type="friends" />}
            </div>

            <p
              id={index === 2 ? 'animatedNumber' : ''}
              className="font-bb text-[4.8vw] lg:text-[1.67vw] lg:leading-[1.67vw] transition-all duration-500 ease-in-out notranslate"
            >
              {index === 2
                ? formatPriceNumberWithSymbol(`${shareStats[item.key]}`, currency)
                : numberFormatToThousands(shareStats[item.key])}
            </p>

            {index === 2 && (
              <p className="text-secondary-text text-[3.2vw] lg:text-[12px] lg:text-[#999] lg:leading-[12px] mt-1 flex items-center">
                ({numberFormatToThousands(shareStats.total_get_points)} {t('points')})
                <QuestionIcon type="points" />
              </p>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ShareStat;
